import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-final-form';

import CardWrapper, { EDIT_PROJECT_SECTION } from '../card-wrapper/CardWrapper';
import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import { changeProjectSharing, changeSharePassword } from '../../../redux/projects/projectsActions';
import CommonSwitch from '../../../components/common-switch/CommonSwitch';
import SharePasswordForm from './SharePasswordForm';
import validate from '../../../utils/validate';
import { changeProjectPasswordFormYopValidation } from '../validation';

import scss from './ShareSection.module.scss';

const ShareSection = () => {
  const { t } = useTranslation('projects');
  const dispatch = useDispatch();
  const { id } = useParams();

  const editProject = useSelector((state) => state.projects.editProject);
  const [isActiveSharing, setIsActiveSharing] = useState(false);

  const passwordInitialValues = {
    link: editProject?.link ?? '',
    password: editProject?.projectPassword ?? '',
  };

  const handleChangeSharing = useCallback(
    (event) => {
      const isActive = event.target.checked;
      setIsActiveSharing(isActive);
      dispatch(changeProjectSharing({ id, activeSharing: isActive }));
    },
    [dispatch, id],
  );

  const handleChangePassword = useCallback(
    (values) => {
      dispatch(changeSharePassword({ id, projectPassword: values.password }));
    },
    [dispatch, id],
  );

  useEffect(() => {
    setIsActiveSharing(editProject?.activeSharing || false);
  }, [editProject]);

  return (
    <CardWrapper label={t('share')} sectionType={EDIT_PROJECT_SECTION.SHARE}>
      <WithLabel label={t('activateSharing')} variant={LABEL_STYLES.CUSTOM} extraClassName={scss.formRow} isBold>
        <CommonSwitch checked={isActiveSharing} onChange={handleChangeSharing} disabled={!editProject} />
      </WithLabel>

      <Form
        initialValues={passwordInitialValues}
        onSubmit={handleChangePassword}
        subscription={{ submitting: true, pristine: true }}
        validate={(values) => validate(values, changeProjectPasswordFormYopValidation())}
        render={({ handleSubmit }) => (
          <SharePasswordForm
            onSubmit={handleSubmit}
            initialValues={passwordInitialValues}
            isPasswordFormDisabled={!isActiveSharing || !editProject}
          />
        )}
      />
    </CardWrapper>
  );
};

export default ShareSection;
